import React from 'react';
import BaseContainer from '../baseContainers/BaseContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import SettingService from '../services/SettingService';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class VersionContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new SettingService();
        this.state = {
            backendVersion: [],
            loading: true,
            uiVersion: {
                appVersion: process.env.REACT_APP_VERSION,
                appName: process.env.REACT_APP_NAME,
                buildNumber: process.env.REACT_APP_BUILD_NUMBER,
                buildTime: process.env.REACT_APP_BUILD_TIME,
            },
        };
    }

    componentDidMount() {
        this.service
            .getVersionInfo()
            .then((backendVersion) => {
                this.setState({backendVersion: Object.entries(backendVersion?.versionInfo), loading: false});
            })
            .catch(() => {
                this.setState({backendVersion: [], loading: false});
            });
    }

    render() {
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.loading} loader={this.loader}></BlockUi>
                <div className='container-fluid'>
                    <div>
                        <div className='col-md-12'>
                            <span style={{fontWeight: 'bold'}}>UI app name: </span>
                            <span>{this.state.uiVersion?.appName}</span>
                        </div>
                        <div className='col-md-12'>
                            <span style={{fontWeight: 'bold'}}>UI app version: </span>
                            <span>{this.state.uiVersion?.appVersion}</span>
                        </div>
                        <div className='col-md-12'>
                            <span style={{fontWeight: 'bold'}}>UI build number: </span>
                            <span>{this.state.uiVersion?.buildNumber}</span>
                        </div>
                        <div className='col-md-12'>
                            <span style={{fontWeight: 'bold'}}>UI build time: </span>
                            <span>{this.state.uiVersion?.buildTime}</span>
                        </div>
                        <div className='col-md-12'></div>
                        {this.state.backendVersion &&
                            this.state.backendVersion?.length > 0 &&
                            this.state.backendVersion.map((b) => {
                                return (
                                    <div className='col-md-12'>
                                        <span style={{fontWeight: 'bold'}}>{b[0]}: </span>
                                        <span>{b[1]}</span>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

VersionContainer.propTypes = {};
export default withRouter(withTranslation()(VersionContainer));
